/**
 * Formats a date string or Date object to dd/MM/yyyy format
 * @param date - Date string (ISO format) or Date object
 * @returns Formatted date string in dd/MM/yyyy format, or '-' if date is invalid
 */
export const formatDate = (date: string | Date | null | undefined): string => {
  if (!date) return '-';

  try {
    const dateObj = typeof date === 'string' ? new Date(date) : date;

    if (isNaN(dateObj.getTime())) {
      return '-';
    }

    const day = String(dateObj.getDate()).padStart(2, '0');
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const year = dateObj.getFullYear();

    return `${day}/${month}/${year}`;
  } catch {
    return '-';
  }
};

/**
 * Formats a date string or Date object to dd/MM/yyyy HH:mm format
 * @param date - Date string (ISO format) or Date object
 * @returns Formatted date-time string in dd/MM/yyyy HH:mm format, or '-' if date is invalid
 */
export const formatDateTime = (date: string | Date | null | undefined): string => {
  if (!date) return '-';

  try {
    const dateObj = typeof date === 'string' ? new Date(date) : date;

    if (isNaN(dateObj.getTime())) {
      return '-';
    }

    const day = String(dateObj.getDate()).padStart(2, '0');
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const year = dateObj.getFullYear();
    const hours = String(dateObj.getHours()).padStart(2, '0');
    const minutes = String(dateObj.getMinutes()).padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}`;
  } catch {
    return '-';
  }
};
